export default __webpack_public_path__ + "static/media/97_QT_Header_2.3a62c2f9.png";